module.exports = __webpack_public_path__ + "img/logoBW.5fe60af6.svg";